export default "__VITE_ASSET__25fb7ea5__"